import { http } from '../services';

class SubeventoService {
    subeventoForm() {
        return http.get('/subeventos/form');
    }

    async getAll({
        pageIndex, rowsPerPage, columnSort, orderSort, searchIndex, searchText, searchOperator,
    }) {
        return http.get('/subeventos', {
            pageIndex,
            rowsPerPage,
            columnSort,
            orderSort,
            searchIndex,
            searchText,
            searchOperator,
        });
    }

    async getSubeventoPeloNome(nome) {
        return this.getAll({
            pageIndex: 1,
            rowsPerPage: 5,
            columnSort: 1,
            orderSort: 'ASC',
            searchIndex: 1,
            searchText: nome,
            searchOperator: 'LIKE',
        });
    }

    async sendVerifyCode(subevento, email) {
        return http.post('/sendverifycode', {
            subevento,
            email
        });
    }

    async checkVerifyCode(subevento, email, code) {
        return http.get('/checkverifycode', {
            code,
            subevento,
            email
        });
    }

    async getSubeventosDoEvento(evento) {
        return http.get('/subeventos/evento', { evento });
    }

    async getSubeventosParaOuvintesDoEvento(evento) {
        return http.get('/subeventos/subeventos-para-ouvintes', { evento });
    }

    getSubeventoPublico(subevento) {
        return http.get(`/subeventos/publico/${subevento}`);
    }

    getSubevento(subevento) {
        return http.get(`/subeventos/${subevento}`);
    }

    save(subevento) {
        return http.post('/subeventos', subevento);
    }

    update(subevento) {
        return http.put('/subeventos', subevento);
    }

    delete(subevento) {
        return http.delete('/subeventos', subevento);
    }
}

const subeventoService = new SubeventoService();
export default subeventoService;
